import { render, staticRenderFns } from "./train-import.vue?vue&type=template&id=ba192446&scoped=true"
import script from "./train-import.vue?vue&type=script&lang=js"
export * from "./train-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba192446",
  null
  
)

export default component.exports